define([
	"dojo/_base/declare",
	"csi",
	"csi/html/Widget",
	"csi/view",
	"./SeasonAvailabilitySwitchboard"
], function(declare,csi,Widget,csiView) {

	return declare(Widget, {
		idChildView: null,
		
		postActionAvailability: function(/*Controller*/ac) {
			// summary: update child view
			this._updateChildView(ac.newValue);
		},
		
		_endView: function() {
			// summary: update child view read-only status
			this._updateChildView(this.getViewNode().HasSeasonAvailability);
			this.inherited(arguments);
		},
		
		_insertView: function(/*csi.def.View*/defView, /*Node*/node, /*Object?*/params, /*Boolean*/bSync) {
			// summary: set read-only status of view and track id
			this.idChildView = defView.m_id;
			return this.inherited(arguments);
		},
		
		_updateChildView: function(/*Boolean*/bAvailability) {
			// summary: set read-only status of child view based on availability setting
			var	view = csiView.getView(this.idChildView);
			if (view) {
				view.defView.setReadOnly(!bAvailability);
				
				if (!view.isLoadingView()) {
					view.redraw();
					view.postAction();
				}
			}
		}
	});
});